import { connect } from 'react-redux';

import {
  actionGetPlaceContacts,
  actionGetPlaceContactDetails,
  actionAddPlaceContact,
  actionEditPlaceContact,
  actionDeletePlaceContact,
} from 'store/place-contacts/actions';
import actionGetSetting from 'store/setting/actions';
import ContactInfo from './ContactInfo';

const mapStateToProps = (state) => ({
  isLoadingGetPlaceContacts: state.PlaceContacts.isLoadingGetPlaceContacts,
  isLoadingGetPlaceContactDetails: state.PlaceContacts.isLoadingGetPlaceContactDetails,
  isLoadingAddPlaceContact: state.PlaceContacts.isLoadingAddPlaceContact,
  isLoadingEditPlaceContact: state.PlaceContacts.isLoadingEditPlaceContact,
  isLoadingDeletePlaceContact: state.PlaceContacts.isLoadingDeletePlaceContact,

  setting: state.Setting.setting,

  placeContactsList: state.PlaceContacts.placeContactsList,
  placeContactDetails: state.PlaceContacts.placeContactDetails,
});

const mapDispatchToProps = (dispatch) => ({
  actionGetPlaceContacts: (payload) => dispatch(actionGetPlaceContacts(payload)),
  actionGetPlaceContactDetails: (payload) => dispatch(actionGetPlaceContactDetails(payload)),
  actionAddPlaceContact: (payload) => dispatch(actionAddPlaceContact(payload)),
  actionEditPlaceContact: (payload) => dispatch(actionEditPlaceContact(payload)),
  actionDeletePlaceContact: (payload) => dispatch(actionDeletePlaceContact(payload)),
  actionGetSetting: (payload) => dispatch(actionGetSetting(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ContactInfo);
